/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-alert-bell';
const componentName = 'avi-alert-bell-body';
const prefix = `${moduleName}.${componentName}`;

export const highLabel = `${prefix}.highLabel`;
export const mediumLabel = `${prefix}.mediumLabel`;
export const lowLabel = `${prefix}.lowLabel`;

export const ENGLISH = {
    [highLabel]: 'High',
    [mediumLabel]: 'Medium',
    [lowLabel]: 'Low',
};
